<template>
    <div>
        <b-row>
            <b-col>
                <b-form bg-variant="light">
                    <b-form-select
                        id="input-role_id"
                        v-model="model.role_id"
                        :options="roles"
                        text-field="name"
                        value-field="id"
                        required
                        trim
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled
                                >-- Please Select the Role
                                --</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form>
            </b-col>
            <b-col>
                <b-button
                    :disabled="!isRoleAvailable"
                    size="sm"
                    variant="success"
                    @click="saveRole"
                >
                    Add Role
                </b-button>
            </b-col>
        </b-row>

        <b-table striped hover :items="typeRoles" :fields="itemFields">
            <template #cell(id)="{ value }">
                <b-button
                    size="sm"
                    @click="deleteRole(value)"
                    class="mr-2"
                    variant="warning"
                >
                    Delete
                </b-button>
            </template>
        </b-table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            itemFields: [
                {
                    key: 'id',
                    label: '',
                },

                {
                    key: 'role_id',
                    label: 'Role',
                    formatter: (value, key, item) => item.role.name,
                },
            ],
            model: {
                id: null,
                role_id: null,
            },
            loading: false,
            itemModal: false,
            modelChanged: false,
        }
    },
    computed: {
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },

        roles() {
            return this.$store.state.roles.items
        },

        checkoffType() {
            return this.$store.state.checkoffTypes.selectedType
        },

        typeRoles() {
            const roles = this.checkoffType.checkoff_type_roles || []
            console.log('checkoff type', roles)
            return roles
        },
        isRoleAvailable() {
            return (
                this.model.role_id &&
                !this.typeRoles.some(x => x.role_id === this.model.role_id)
            )
        },
    },
    watch: {},

    methods: {
        async viewRole(id) {
            /* if the template exists find the item among the template's 
            types otherwise, firnd the item among the template model's types */
            const templateType =
                this.template.types.find(x => x.id === id) || {}
            this.model = { ...templateType }
            this.itemModal = true
        },
        deleteRole(id) {
            this.loading = true
            // if the template exists delete the master item from the database

            const path = `checkoffTypes/deleteRole`
            const checkoff_type_id = this.checkoffType.id

            this.$store
                .dispatch(path, { checkoff_type_id, id })
                .then(() => {
                    this.loading = false
                    this.itemModal = false
                    this.modelChanged = false
                })
                .catch(error => {
                    console.log('error', error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        saveRole() {
            const {
                model: { role_id },
                checkoffType: { id: checkoff_type_id },
            } = this

            // if the template exists add the master item to the template in the database or update it in the database
            const path = `checkoffTypes/createRole`

            this.loading = true
            this.$store
                .dispatch(path, { checkoff_type_id, role_id })
                .then(() => {
                    this.loading = false
                    this.itemModal = false
                    this.modelChanged = false
                })
                .catch(error => {
                    console.log('error', error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>
